export enum RealtimeEventTypeEnum {
  audioTranscriptDoneFromAssistant = 'response.audio_transcript.done',
  audioTranscriptDoneFromCustomer = 'conversation.item.input_audio_transcription.completed',
}
